import { render } from "./Bye.vue?vue&type=template&id=6bdd842c&scoped=true"
const script = {}

import "./Bye.vue?vue&type=style&index=0&id=6bdd842c&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\Papawash_build\\build\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bdd842c"]])

export default __exports__